<h1 mat-dialog-title>Third-Party Licenses</h1>
<div mat-dialog-content>
  @for (license of licenses; track license) {
    <div>
      <h2>{{ license.name }}</h2>
      <pre>{{ license.license }}</pre>
    </div>
  }
</div>
<div mat-dialog-actions>
  <button mat-button (click)="dialogRef.close()">Close</button>
</div>
